const titleCase = (s) => (s || "").toLowerCase().replace(/(^|[\s_\-.(])(\p{L})/gu, (m, p, c) => p + c.toUpperCase());

const OPTS = [
  { k: "upper", l: "AA", t: "MAIUSCOLO", f: (s) => (s || "").toUpperCase() },
  { k: "lower", l: "aa", t: "minuscolo", f: (s) => (s || "").toLowerCase() },
  { k: "title", l: "Aa", t: "Iniziali Maiuscole", f: titleCase },
];

const keepExt = (s, f) => { const m = /^(.*?)(\.[A-Za-z0-9]{1,5})$/.exec(s || ""); return m && m[1] ? f(m[1]) + m[2] : f(s); };

// Pulsanti rapidi per cambiare maiuscole/minuscole del nome file.
export default function NameCaseButtons({ value, onChange, testId = "name-case", small = false }) {
  return (
    <div className="flex items-center gap-0.5 shrink-0" data-testid={testId}>
      {OPTS.map((o) => (
        <button key={o.k} type="button" title={o.t} data-testid={`${testId}-${o.k}`}
          onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onClick={(e) => { e.stopPropagation(); onChange(keepExt(value, o.f)); }}
          className={`rounded border font-mono font-semibold transition-colors ${small ? "border-slate-300 bg-white text-slate-700 hover:border-amber-500 hover:text-amber-600 px-1.5 text-[10px] leading-4" : "border-slate-700 bg-slate-900/70 text-slate-300 hover:border-amber-500 hover:text-amber-400 px-1.5 py-0.5 text-[11px]"}`}>
          {o.l}
        </button>
      ))}
    </div>
  );
}
